export const randomIntFromInterval = (min, max): number => { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export const intToRomanNumber = (x: number): string => {
	switch (x) {
		case 1:
			return "I";
		case 2:
			return "II";
		case 3:
			return "III";
		case 4:
			return "IV";
		case 5:
			return "V";
		case 6:
			return "VI";
		case 7:
			return "VII";
		case 8:
			return "VIII";
		case 9:
			return "IX";
		case 10:
			return "X";
		case 11:
			return "XI";
		case 12:
			return "XII";
		case 13:
			return "XIII";
		case 14:
			return "XIV";
		case 15:
			return "XV";
		case 16:
			return "XVI";
		case 17:
			return "XVII";
		case 18:
			return "XVIII";
		case 19:
			return "XIX";
		case 20:
			return "XX";
		default:
			return x.toString();
	}
};

export const intToGreekLetter = (x: number): string => {
	switch (x) {
		case 1:
			return "alpha";
		case 2:
			return "beta";
		case 3:
			return "gamma";
		case 4:
			return "delta";
		case 5:
			return "epsilon";
		case 6:
			return "zeta";
		case 7:
			return "eta";
		case 8:
			return "theta";
		case 9:
			return "iota";
		case 10:
			return "kappa";
		case 11:
			return "lambda";
		case 12:
			return "mu";
		case 13:
			return "nu";
		case 14:
			return "xi";
		case 15:
			return "omicron";
		case 16:
			return "pi";
		case 17:
			return "rho";
		case 18:
			return "sigma";
		case 19:
			return "tau";
		case 20:
			return "upsilon";
		case 21:
			return "phi";
		case 22:
			return "chi";
		case 23:
			return "psi";
		case 24:
			return "omega";
		default:
			return x.toString();
	}
};

export const intToLetter = (x: number): string => {
	return String.fromCharCode(96 + x);
};

export const secondsToTime = (seconds: number): string => {
  if (seconds === null || isNaN(seconds)) return "";
  const time = Math.floor(seconds);
  const mins = Math.floor(time / 60);
  const secs = Math.round(time % 60);
  return `${mins}:${secs < 10 ? "0" + secs : secs}`;
};